// Shared by the HR app (lib/api.ts) and the candidate app (careers), which must not pull
// in the HR api module with its session handling.
export const resolveBaseUrl = () => {
  const configuredUrl = (import.meta.env.VITE_API_URL || '').trim();
  const defaultUrl = '/api';
  if (!configuredUrl) return defaultUrl;
  const isBrowser = typeof window !== 'undefined';
  const isSecureContext = isBrowser && window.location.protocol === 'https:';
  const isInsecureConfiguredUrl = configuredUrl.startsWith('http://');
  if (isSecureContext && isInsecureConfiguredUrl) {
    return defaultUrl;
  }
  return configuredUrl;
};
